export default __webpack_public_path__ + "static/media/removeIcon.2dac5985.svg";